module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/12.11fff5d1.png";